import { SiteThemeProps } from "@inferno/renderer-shared-core";
import { Routes } from "../Routes";
import "./embed.style.scss";

export default ({ siteTheme }: SiteThemeProps) => <Routes siteTheme={siteTheme} useStoredPage={true} />;
